import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";


export default function ProgramsMoreDetails() {
  const location = useLocation();
  const programDetails = location.state?.programDetails;
  const ONEcommunityDetailss =
    programDetails?.ONEcommunityDetailss?.[0]?.EntityInfo;


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  return (
    <div className="font-sans bg-gray-50 min-h-screen">

      <section className="relative">
        <img
          src={programDetails?.CoverImageUrl}
          alt="Community Cover"
          className="w-full h-[350px] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent flex flex-col justify-center px-8">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white drop-shadow-lg">
            {programDetails?.Name}
          </h1>
          <p className="text-lg md:text-2xl text-gray-200 mt-3 max-w-3xl">
            {programDetails?.Description}
          </p>
        </div>
      </section>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6 py-12 px-6">
        {[
          { label: "Start Date", value: programDetails?.StartDateUtc },
          { label: "Name", value: programDetails?.Name },
          { label: "End Date", value: programDetails?.EndDateUtc },
        ].map((stat, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-transform duration-300 hover:-translate-y-1 text-center"
          >
            <p className="text-4xl font-bold text-orange-500">{stat.value}</p>
            <p className="text-gray-600 font-medium">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

